import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    securityRole: null,
    securityAccess: null,
    email: null,
    mfaActive: null,
    mfaRefId: null,
    pinConfiguration: null,
    parentuserid: null,
    deviceToken: null,
    sessionID: null,
    defaultLogin: null,
    loginType: null
  },

  reducers: {
    setLoggedInUser: (state, action) => {
      // console.log(action)
      state.user = action.payload.payload.body.User;
      state.securityRole = action.payload.payload.body.Securityuserrole;
      state.securityAccess = action.payload.access;
      state.email = action.payload.payload.body.Useremailaccount;
      state.mfaActive = action.payload.isActive;
      state.mfaRefId = action.payload.refId;
      state.pinConfiguration = action.payload.pinConfig;
      state.parentuserid = action.payload.parentuserid
      // console.log(action)
    },
    setLoggedOutUser: (state) => {
      state.user = null;
    },
    setAuthenticatedLoggedInUsers: (state, action) => {
      // console.log(action)
      // state.user = action.payload
      state.user = action.payload.payload.body.User;
      state.securityRole = action.payload.payload.body.Securityuserrole;
      state.securityAccess = action.payload.access;
      state.email = action.payload.payload.body.Useremailaccount;
      state.mfaActive = action.payload.isActive;
      state.mfaRefId = action.payload.refId;
      state.pinConfiguration = action.payload.pinConfig;
      // console.log(action)
    },
    setDeviceToken: (state, action) => {
      state.deviceToken = action.payload; // Action to store deviceToken
    },
    clearDeviceToken: (state) => {
      state.deviceToken = null; // Action to clear deviceToken
    },
    setSessionID: (state, action) => {
      state.sessionID = action.payload; // Action to store deviceToken
    },
    clearSessionID: (state) => {
      state.sessionID = null; // Action to clear deviceToken
    },
    setDefaultLogin: (state, action) => {
      state.defaultLogin = action.payload;
    },
    setLoginType: (state, action) => {
      state.loginType = action.payload;
    }
  },  
});

export const setLoggedInUser = userSlice.actions.setLoggedInUser;
export const setLoggedOutUser = userSlice.actions.setLoggedOutUser;
export const setAuthenticatedLoggedInUsers = userSlice.actions.setAuthenticatedLoggedInUsers;
export const setDeviceToken = userSlice.actions.setDeviceToken;
export const setSessionID = userSlice.actions.setSessionID;
export const setDefaultLogin = userSlice.actions.setDefaultLogin;
export const setLoginType = userSlice.actions.setLoginType;

export default userSlice.reducer;
